// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2wIer","addWidgetButton":"Header_addWidgetButton__3dS_L","dashboardTabs":"Header_dashboardTabs__Wg13T","active":"Header_active__3NhRX"};